import {ResellJourneyBundleMutation} from "./resell-journey-bundle-mutation";
import {JourneyModel} from "../../journey/journey.model";

export class ResellDepartureJourneyBundleMutation extends ResellJourneyBundleMutation {

    get journey(): JourneyModel {
        const journey = this.booking.unfilteredJourneys[0];

        if(!journey?.journeyKey) {
            throw new Error('There is no departure journey');
        }
        return journey;
    }
}
